<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">Virginie Boreham RIP ‘Gini’</p><br/>
<p style="text-align: center;">Lloyd and Margot</p><br/>
<p style="text-align: center;">My wicked stepmother</p><br/>
<p style="text-align: center;">Father</p><br/>
<p style="text-align: center;">Diana</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?04587482